export default __webpack_public_path__ + "static/media/user.5d45d3c5.jpg";